<template>
  <v-tooltip top :disabled="!hasTooltip">
    <template #activator="{ on, attrs }">
      <v-btn @click="onButtonClick" v-on="on" v-bind="attrs" icon color="primary">
        <v-icon>mdi-reload</v-icon>
      </v-btn>
    </template>
    {{ buttonText }}
  </v-tooltip>
</template>

<script>
export default {
  props: {
    buttonText: {
      default: 'Recarregar listagem',
      type: String
    },
    hasTooltip: {
      default: true,
      type: Boolean
    }
  },
  methods: {
    onButtonClick() {
      this.$emit('click');
    }
  }
};
</script>

<style></style>
